import React, { useRef } from "react"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Edges from "../../Edges"
import Slider from "react-slick"
import ArrowRight from "../../../icons/ArrowRight.svg"
import ArrowLeft from "../../../icons/ArrowLeft.svg"

interface IImageCarousel {
  images: Array<any>
  headline: string
}

export const ImageCarousel = ({ images = [], headline }: IImageCarousel) => {
  const sliderSettings = {
    arrows: false,
    dots: false,
    infinite: images?.length >= 4 ? true : false,
    autoplay: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  const sliderRef = useRef()

  const nextSlide = e => {
    e && sliderRef?.current?.slickNext()
  }
  const prevSlide = e => {
    e && sliderRef?.current?.slickPrev()
  }

  return (
    images && (
      <div className="mb-[40px] bg-darkBlue">
        <Edges size="xl">
          <h2 className="pt-[30px] text-center text-white">{headline}</h2>
          <div
            className={
              headline
                ? "relative flex w-full flex-row items-center justify-center pt-[30px] pb-[60px]"
                : "relative flex w-full flex-row items-center justify-center py-[60px]"
            }
          >
            <button
              className="absolute left-5 flex xl:left-[-75px]"
              onClick={e => prevSlide(e)}
              aria-label="arrow-left"
            >
              <ArrowLeft className="cursor-pointer" fill="#FED844" />
            </button>
            <div className="w-[80%] xl:w-full">
              {images && (
                <Slider {...sliderSettings} ref={sliderRef}>
                  {images?.map((image, index) => {
                    const gatsbyImage =
                      image && getImage(image.image.gatsbyImage)

                    return (
                      <div key={index}>
                        {gatsbyImage && (
                          <div className="mx-[15px] flex justify-center ">
                            <GatsbyImage
                              key={index}
                              image={gatsbyImage}
                              alt={image?.altText ? image?.altText : ""}
                            />
                          </div>
                        )}
                      </div>
                    )
                  })}
                </Slider>
              )}
            </div>
            <button
              className="absolute right-5 flex xl:right-[-75px]"
              onClick={e => nextSlide(e)}
              aria-label="arrow-right"
            >
              <ArrowRight className="cursor-pointer" fill="#FED844" />
            </button>
          </div>
        </Edges>
      </div>
    )
  )
}

export default ImageCarousel

export const fragment = graphql`
  fragment ImageCarousel on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_ImageCarousel {
      fieldGroupName
      headline
      images {
        image {
          altText
          gatsbyImage(
            width: 200
            height: 300
            quality: 100
            placeholder: BLURRED
            fit: OUTSIDE
            formats: [AUTO, WEBP]
          )
        }
      }
    }
  }
`
